import { AxiosInstance } from 'axios';
import firebase from 'firebase/app';
import 'firebase/messaging';
import firebaseConfig, { vapidKey } from '@/config/firebase';

export const fireBase = firebase.initializeApp(firebaseConfig);

export async function subscribeToServer(axios: AxiosInstance) {
  try {
    const serviceWorkerRegistration =
      await navigator.serviceWorker.getRegistration();
    const token = await firebase.messaging().getToken({
      vapidKey,
      serviceWorkerRegistration,
    });
    const subscription = {
      token,
    };
    await axios.post('/authentication/staff/subscribe', { subscription });
    return true;
  } catch (e) {
    console.error(e);
    throw new Error('internal-error');
  }
}

export default async function registerNotification(axios: AxiosInstance) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.error(new Error('browser-not-support'));
    return false;
  }
  const permissionResult = await Notification.requestPermission();
  if (permissionResult !== 'granted') {
    console.error(new Error('permission-block'));
    return false;
  }
  return subscribeToServer(axios);
}
